const translate = {
    portugues: {
        title: 'Videos Downloads',
        subTitle: 'Informe seus dados de acesso abaixo.',
        myVideos: 'Meus Videos',
        addCredits: 'Adicionar Créditos',
        myHistory: 'Meu Histórico ',
        labelVideosDown: 'Confira abaixo os seus vídeos solicitados',
        subLabelVideosDown: 'Aqui você pode conferir os seus vídeos',
        totalDownloads: 'Total de Downloads',
        totalCredits: 'Créditos Totais',
        hello: 'Olá',
        sweetDo: ' confira o histórico de seus videos',
        orderStatus: 'Status do Video',
        orderVideoName: 'Nome do Video',
        orderCreditUsed: 'Créditos Usados',
        orderLinkDownload: 'Link Download',
        orderDate: 'Data Solicitada',
        orderDateExpired: 'Data Expirada',
    },
    ingles: {
        title: 'Painel de Downloads',
        subTitle: 'Enter your access details below.',
        myVideos: 'My Videos',
        addCredits: 'Add credits',
        myHistory: 'My History',
        labelVideosDown: 'Check out his videos below',
        subLabelVideosDown: 'Here you can check out his videos',
        totalDownloads: 'Total Downloads',
        totalCredits: 'Total Credits',
        hello: 'Hello',
        sweetDo: 'choose what you want to do',
        orderStatus: 'Video Status',
        orderVideoName: 'Video Name',
        orderCreditUsed: 'Credits Used',
        orderLinkDownload: 'Link Download',
        orderDate: 'Date Solicited',
        orderDateExpired: 'Data Expired',
    }
}

export default translate
